import validatePhone from 'phone';
import {PhoneNumber} from 'platform/components';
import {z} from 'zod';

import {isNilOrEmpty} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

const NAME_REGEX = /^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF-\s.]+$/i;
const NAME_MAX_LENGTH = 60;

const phoneNumberSchema = z
  .custom<PhoneNumber | Nullish>()
  .refine(
    (phone) => {
      if (isNilOrEmpty(phone?.number)) {
        return true;
      }

      return validatePhone(phone?.number || '', {
        country: phone?.countryCode,
        validateMobilePrefix: false,
      }).isValid;
    },
    {
      message: i18n.t('general.validations.invalidPhoneNumber'),
    }
  )
  .nullable();

export const PersonalInformationFormSchema = z.object({
  firstName: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .min(1, i18n.t('general.validations.fieldIsRequired'))
    .regex(NAME_REGEX, i18n.t('general.notifications.invalidFirstName'))
    .max(NAME_MAX_LENGTH, i18n.t('general.notifications.invalidFirstName')),
  lastName: z
    .string({required_error: i18n.t('general.validations.fieldIsRequired')})
    .min(1, i18n.t('general.validations.fieldIsRequired'))
    .regex(NAME_REGEX, i18n.t('general.notifications.invalidLastName'))
    .max(NAME_MAX_LENGTH, i18n.t('general.notifications.invalidLastName')),
  phoneNumber: phoneNumberSchema,
});

export type PersonalInformationFormSchemaType = z.infer<typeof PersonalInformationFormSchema>;
